var map = {
	"./basic/basic.ts": "./src/playground/skeleton/basic/basic.ts",
	"./basic/basic_boolean_field.ts": "./src/playground/skeleton/basic/basic_boolean_field.ts",
	"./basic/basic_button.ts": "./src/playground/skeleton/basic/basic_button.ts",
	"./basic/basic_button_disabled.ts": "./src/playground/skeleton/basic/basic_button_disabled.ts",
	"./basic/basic_create.ts": "./src/playground/skeleton/basic/basic_create.ts",
	"./basic/basic_create_value.ts": "./src/playground/skeleton/basic/basic_create_value.ts",
	"./basic/basic_define.ts": "./src/playground/skeleton/basic/basic_define.ts",
	"./basic/basic_double_loop.ts": "./src/playground/skeleton/basic/basic_double_loop.ts",
	"./basic/basic_event.ts": "./src/playground/skeleton/basic/basic_event.ts",
	"./basic/basic_loop.ts": "./src/playground/skeleton/basic/basic_loop.ts",
	"./basic/basic_param.ts": "./src/playground/skeleton/basic/basic_param.ts",
	"./basic/basic_string_field.ts": "./src/playground/skeleton/basic/basic_string_field.ts",
	"./basic/basic_text.ts": "./src/playground/skeleton/basic/basic_text.ts",
	"./basic/basic_text_light.ts": "./src/playground/skeleton/basic/basic_text_light.ts",
	"./clickable_text.ts": "./src/playground/skeleton/clickable_text.ts",
	"./comment.ts": "./src/playground/skeleton/comment.ts",
	"./pebble/pebble_basic.ts": "./src/playground/skeleton/pebble/pebble_basic.ts",
	"./pebble/pebble_event.ts": "./src/playground/skeleton/pebble/pebble_event.ts",
	"./pebble/pebble_loop.ts": "./src/playground/skeleton/pebble/pebble_loop.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/playground/skeleton sync recursive ^(?%21.*index.[jt]s)(.*\\.[jt]s$)im";